import React, { useState, useRef } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import Slider from 'react-slick'
import Icons from '../../myIcon/Icons'

const CENTER_PADDING = 0.22

export default function OtherRoom({otherRoom, roomTitle}) {
  const navigate = useNavigate()
  const [active, setActive] = useState(0)
  const [cursorPos, setCursorPos] = useState({ x: 0, y: 0 })
  const [cursorZone, setCursorZone] = useState('right')
  const [cursorVisible, setCursorVisible] = useState(false)
  const sliderRef = useRef(null)
  const settings = {
    dots: false,
    arrows: false,
    autoplay: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: '20%',
    cssEase: 'ease',
    focusOnSelect: false,
    pauseOnHover: false,
    beforeChange: (current, next) => setActive(next),
    responsive: [
        {
            breakpoint: 599,
            settings: { slidesToShow: 1, centerPadding: '0%',},
        },
    ],
  }

  const getZone = (e) => {
    const rect = e.currentTarget.getBoundingClientRect()
    const ratio = (e.clientX - rect.left) / rect.width
    if (ratio < CENTER_PADDING) return 'left'
    if (ratio > 1 - CENTER_PADDING) return 'right'
    return 'center'
  }

  const handleMouseMove = (e) => {
    setCursorPos({ x: e.clientX, y: e.clientY })
    setCursorZone(getZone(e))
  }

  const handleClick = (e) => {
    const zone = getZone(e)
    if (zone === 'left') sliderRef.current.slickPrev()
    else if (zone === 'right') sliderRef.current.slickNext()
    else navigate(otherRoom?.slides?.[active]?.slug)
  }

  const cursorIcon = cursorZone === 'center' ? 'plus' : cursorZone === 'left' ? 'arrowLeft' : 'arrowRight'

  return (
    <section className="room-slider-section">
      <h4 className="heading center-heading">Further Rooms & Suites</h4>

      <div className="room-slider"
        onMouseMove={handleMouseMove}
        onMouseEnter={() => setCursorVisible(true)}
        onMouseLeave={() => setCursorVisible(false)}
        onClick={handleClick}>
        {otherRoom.slides.map((slide, i) => (
          <div key={i} className={`room-slider-bg ${active === i ? 'active' : ''}`}
            style={{ backgroundImage: `url(${slide.bg})` }}/>
        ))}

        <div className="room-slider-inner">
          <Slider ref={sliderRef} {...settings}>
            {otherRoom?.slides?.map((slide, i) => (
              <div key={i}>
                <div className="roomslider-item">
                  <span className="heading">{slide.title}</span>
                  <ul className="roomslide-details">
                    {slide.details.map((item, idx) => (
                      <li key={idx}>{item}</li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </Slider>
        </div>

        <div className="room-slider-footer">
          <Link to={otherRoom?.allRoom?.link} className="arrow-butn longarrow-butn"
            onClick={(e) => e.stopPropagation()}
            onMouseEnter={() => setCursorVisible(false)}
            onMouseLeave={() => setCursorVisible(true)}>
            <span class="sr-only">{roomTitle} </span>View All Rooms <img src="/image/longright-arrow.svg" alt="arrow" />
          </Link>
        </div>
      </div>

      <div className={`slider-cursor ${cursorVisible ? 'visible' : ''}`} style={{ left: cursorPos.x, top: cursorPos.y }}>
        <Icons name={cursorIcon} />
      </div>
    </section>
  )
}
